export default __webpack_public_path__ + "static/media/mobile-creative-bg.56c74dba.png";